import { render, staticRenderFns } from "./GameRecommend.vue?vue&type=template&id=220f2ba9&scoped=true"
import script from "./GameRecommend.vue?vue&type=script&lang=ts"
export * from "./GameRecommend.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameRecommend.vue?vue&type=style&index=0&id=220f2ba9&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "220f2ba9",
  "fed23c1a"
  
)

export default component.exports